/**
 * Filter po periodu: brzi izbor plus dva polja, od i do.
 *
 * Brzi izbor ne zamenjuje polja nego ih popunjava, pa se uvek vidi koji je tačno opseg
 * aktivan. Spisak unapred ponuđenih meseci ovde ne bi radio: istorija ide od 2003, što je
 * preko dvesta stavki, a ni tada se ne bi moglo tražiti „od 15.03. do 20.04."
 */
import { useTranslation } from "react-i18next";
import { DATE_PRESETS, presetForRange, presetRange, type DatePreset } from "../lib/datePresets";

export function DateRangeFilter({
  from,
  to,
  onChange,
  now = new Date(),
  /** Koje prečice ekran nudi. Radni spiskovi traže pomične, izveštaji kalendarske. */
  preseci = DATE_PRESETS,
  /** Ponovni klik skida period. Gde je opseg obavezan, skidanje se ne nudi. */
  moze_bez = true,
}: {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
  now?: Date;
  preseci?: DatePreset[];
  moze_bez?: boolean;
}) {
  const { t } = useTranslation();
  const aktivan = presetForRange(from, to, now, preseci);

  const nazivi: Record<DatePreset, string> = {
    today: t("filter.period.today", "Danas"),
    last3: t("filter.period.last3", "3 dana"),
    last7: t("filter.period.last7", "7 dana"),
    last30: t("filter.period.last30", "30 dana"),
    thisWeek: t("filter.period.thisWeek", "Ova nedelja"),
    thisMonth: t("filter.period.thisMonth", "Ovaj mesec"),
    thisQuarter: t("filter.period.thisQuarter", "Kvartal"),
    thisYear: t("filter.period.thisYear", "Godina"),
    all: t("filter.period.all", "Sve"),
  };

  return (
    <div style={okvir}>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {preseci.map((p) => {
          const izabran = aktivan === p;
          return (
            <button
              key={p}
              type="button"
              className={izabran ? "btn primary" : "btn"}
              aria-pressed={izabran}
              onClick={() => {
                // Ponovni klik na izabrani period ga skida, umesto da ne radi ništa.
                const r = presetRange(izabran && moze_bez ? "all" : p, now);
                onChange(r.from, r.to);
              }}
            >
              {nazivi[p]}
            </button>
          );
        })}
      </div>
      <label style={polje}>
        <span className="dr-oznaka">{t("filter.period.from", "Od")}</span>
        <input type="date" className="input" value={from} max={to || undefined}
               onChange={(e) => onChange(e.target.value, to)} />
      </label>
      <label style={polje}>
        <span className="dr-oznaka">{t("filter.period.to", "Do")}</span>
        <input type="date" className="input" value={to} min={from || undefined}
               onChange={(e) => onChange(from, e.target.value)} />
      </label>
      {moze_bez && (from || to) && (
        <button type="button" className="btn ghost sm" onClick={() => onChange("", "")}>
          {t("filter.period.clear", "Poništi period")}
        </button>
      )}
    </div>
  );
}

const okvir: React.CSSProperties = {
  display: "flex", alignItems: "flex-end", gap: 10, flexWrap: "wrap",
};
const polje: React.CSSProperties = { display: "flex", flexDirection: "column", gap: 4 };

